import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

/**
 * Format for configurable background images
 * @example
 *   "backgroundImage": {
 *      "url": "https://images.unsplash.com/photo-1517554558809-9b4971b38f39",
 *      "positionX": "25%",
 *      "positionY": "25%",
 *      "size": "cover",
 *      "repeat": "no-repeat"
 *   }
 */
export interface UIBackgroundImageConfig {
  url: string;
  positionX: string;
  positionY: string;
  size: 'cover' | 'contain';
  repeat: 'repeat' | 'no-repeat';
}

/**
 * Sets CSS background image properties for a given HTML element based on configuration
 * @example
 *   <div [ui-background-img]="config.backgroundImage"></div>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ui-background-img]',
})
export class UIBackgroundImageDirective implements AfterViewInit, OnChanges {
  @Input('ui-background-img') config!: UIBackgroundImageConfig;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.applyStyles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.applyStyles();
    }
  }

  applyStyles() {
    const el = this.elementRef.nativeElement;

    this.renderer.setStyle(el, 'background-image', this.getImageUrl());
    this.renderer.setStyle(el, 'background-position-x', this.config.positionX);
    this.renderer.setStyle(el, 'background-position-y', this.config.positionY);
    this.renderer.setStyle(el, 'background-size', this.config.size);
    this.renderer.setStyle(el, 'background-repeat', this.config.repeat);
  }

  getImageUrl(): string {
    return `url(${this.config.url})`;
  }
}
